/**
 * Every mark a guided-tour step can point at (#234): a step names one as its
 * `target`, and the element it points at carries it as `data-tour` (spread
 * from `toTourTargetProps`), so a renamed mark is a type error on both sides
 * rather than a step silently passed over.
 */
export const TOUR_TARGETS = [
    'action-bar',
    'attributes',
    'carried',
    'character',
    'commissions',
    'crafting-items',
    'crafting-vessel',
    'crafting-workbench',
    'crucible-info',
    'crucibles-actions',
    'crucibles-list',
    'crucibles-locked',
    'essence-bar',
    'featured-crucibles',
    'header-account',
    'hud-carried',
    'hud-commission',
    'hud-map',
    'hud-party',
    'journey-books',
    'loadout',
    'mastery-dials',
    'ready-toggle',
    'settings',
    'skills-panel',
    'storage',
    'tabs',
    'vessel',
] as const;

export type TourTarget = typeof TOUR_TARGETS[number];

/** The attribute that marks an element as `target` for the guided tours. */
export function toTourTargetProps(target: TourTarget): { readonly 'data-tour': TourTarget } {
    return { 'data-tour': target };
}
